import { FilteredDropDownModel, ListModel } from "shared/interfaces/core-interfaces";
import yup from "../../../../shared/validation/yupExtensions";

export interface TasksSliceModel {
    task?: Task,
    taskModel: TaskModel,
    tasksByContact: Task[],
    tasksByCompany: Task[],
    tasksByEmployee: Task[],
    tasksByCreator: Task[],

    statusCode: string,
    message: string,
    showNotification: boolean,
    reloadData: boolean,

    isLoading: boolean,

    filteredPartnersList: FilteredDropDownModel,
    filteredContactsList: FilteredDropDownModel,
}

export interface Task {
    taskDate: Date;
    id: string,
    name: string,
    activityDate: Date | undefined,
    taskTypeId: number,
    taskType: string,
    priorityId: number | null,
    priority: string | null,
    reminder: number,
    assignedToId: string,
    assignedTo: string,
    taskNote: string,
    contacts: ListModel<string>[] | [],
    companies: ListModel<string>[] | [],
    taskStatusId: number,
    taskStatus: string,
    createdById: string,
    createdAt: Date,
    createdByFullName: string,
}

export interface CreateTaskRequest {
    associatedCompanies: (string)[] | null,
    associatedContacts: (string)[] | null,
    taskDate: Date | null,
    priority: number | null,
    type: number,
    assignedToId: string,
    name: string, // done
    note: string | null, // done
    reminder: number | null,
}

export interface UpdateTaskRequest {
    id: string | null,
    associatedCompanies: (string)[] | null,
    associatedContacts: (string)[] | null,
    taskDate: Date | null,
    priority: number | null,
    type?: number | null,
    assignedToId: string,
    name: string, // done
    note: string | null, // done
    reminder: number | null,
    taskStatusId: number | null,
}

// --------------------------------

const nonWhitespaceRegExp = /^(?!\s*$).+/;

export interface TaskModel {
    id: string | null,
    associatedCompanies: ListModel<string>[] | [],
    associatedContacts: ListModel<string>[] | [],
    taskDate: Date | null,
    priorityId: number | null,
    typeId: number | null,
    assignedToId: string,
    name: string,
    note: string | null,
    reminder: number | null,
    taskStatusId: number | null,
}

export const initialTaskValue: TaskModel = {
    id: null,
    name: '',
    associatedCompanies: [],
    associatedContacts: [],
    taskDate: null,
    priorityId: 0,
    typeId: 0,
    assignedToId: "",
    note: '',
    reminder: 0,
    taskStatusId: 0,
}

export const TaskModelSchema = yup.object().shape({
    id: yup.string().defined().nullable(),
    associatedCompanies: yup.array().defined(),
    associatedContacts: yup.array().defined(),
    taskDate: yup.date().typeError("Please type valid date.").required("Deadline is required.").nullable()
        .test("is-required", "Deadline is required.", (value) => value !== null),
    priorityId: yup.number().min(1, "Priority is required.").required("Priority is required.").nullable(),
    typeId: yup.number().required().min(1, "Type is required.").required("Type is required.").nullable(),
    assignedToId: yup.string().required("Assigned to is required.").default(""),
    name: yup.string().required("Name is required.").min(1, "Name is required.").matches(nonWhitespaceRegExp, "Name cannot be empty or whitespace.").default(""),
    note: yup.string().nullable().default(""),
    reminder: yup.number().nullable().default(null),
    taskStatusId: yup.number().nullable().default(null),
});

export const getTaskModelSchema = (isCommunicationList: boolean) => yup.object().shape({
    id: yup.string().defined().nullable(),
    associatedCompanies: yup.array().defined(),
    associatedContacts: yup.array().defined(),
    taskDate: yup.date().typeError("Please type valid date.").required("Deadline is required.").nullable()
        .test("is-required", "Deadline is required.", (value) => value !== null),
    priorityId: yup.number().min(1, "Priority is required.").required("Priority is required.").nullable(),
    typeId: yup.number().required().min(1, "Type is required.").required("Type is required.").nullable(),
    assignedToId: yup.string().required("Assigned to is required.").default(""),
    name: isCommunicationList
        ? yup.string().default("")
        : yup.string().required("Name is required.").min(1, "Name is required.").matches(nonWhitespaceRegExp, "Name cannot be empty or whitespace.").default(""),
    note: yup.string().nullable().default(""),
    reminder: yup.number().nullable().default(null),
    taskStatusId: yup.number().nullable().default(null),
});